import {
  makeAboutUsScreen,
  makeCasesScreen,
  makeContactUsScreen,
  makeHomeScreen,
  makeRedirectBienalScreen,
} from '../factory/default';
import { Route } from '../types/use-routes.interface';

export const mainRoutes: Route[] = [
  makeHomeScreen(),
  makeContactUsScreen(),
  makeCasesScreen(),
  makeAboutUsScreen(),
  makeRedirectBienalScreen(),
];
